<template>
  <div class="pt-3 d-flex justify-center">
    <div class="_temp_list">
      <title-page
        title="Scholar Download report"
        :back="true"
        colorIconBack="#006341"
      />
      <v-card class="pa-3" flat>
        this page is a list of scholars who download the report
      </v-card>
      <div class="d-flex justify-end mt-2">
        <v-btn
          class="text-capitalize"
          @click="exportData"
          depressed
          dark
          color="var(--g)"
        >
          <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
          Export Data
        </v-btn>
      </div>
      <v-row align="center" class="my-2">
        <v-col cols="12" md="6">
          <p class="default_txt">Search</p>
          <v-text-field
            placeholder="Search Scholar"
            solo
            dense
            v-model="find"
            @keyup="fetchData"
            hide-details
            prepend-inner-icon="mdi-magnify"
            flat
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <p class="default_txt">Year TF</p>
          <v-select
            :items="getYear"
            item-text="state"
            item-value="abbr"
            v-model="year"
            placeholder="Select Year"
            dense
            flat
            hide-details
            solo
            @change="fetchData"
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <p class="default_txt">Phase</p>
          <v-select
            hide-details
            :items="listPhase"
            flat
            item-value="val"
            item-text="txt"
            dense
            solo
            v-model="phase"
            @change="fetchData"
            placeholder="Status"
          ></v-select>
        </v-col>
      </v-row>
      <div v-if="dataSet && !loading">
        <div v-if="dataSet.length">
          <v-card
            class="pa-3 mb-2 d-flex justify-space-between"
            flat
            v-for="(item, i) in dataSet"
            :key="i"
          >
            <div class="d-flex">
              <v-avatar size="40" class="mr-2">
                <img
                  :src="
                    item.scholar.profile_picture
                      ? item.scholar.profile_picture
                      : ava
                  "
                  class="obj_fit"
                  alt="isyan"
                />
              </v-avatar>
              <div>
                <b class="color_default">{{ item.scholar.name }}</b>
                <p class="default_txt">{{ item.scholar.no_tf }}</p>
              </div>
            </div>
            <div class="d-flex">
              <div class="mr-2">
                <p class="default_txt">{{ item.phase }}</p>
                <p class="ma-0 text-center">
                  <b class="color_default"> {{ item.download_count }} </b>
                </p>
              </div>
              <v-btn dark depressed color="var(--g)" @click="viewDetail(item)"
                >Detail</v-btn
              >
            </div>
          </v-card>
          <div class="text-center pa-3 mt-3">
            <v-pagination
              class="custom_vgn"
              v-model="page"
              color="var(--g)"
              @input="fetchData"
              :length="last_page"
            ></v-pagination>
          </div>
        </div>
        <div
          v-if="!dataSet.length"
          style="height: 300px"
          class="d-flex align-center justify-center flex-column"
        >
          <img
            src="../../../assets/img/gundam/no_data_general.png"
            height="200px"
            alt=""
          />
          <b class="default_txt my-3">No Data Found</b>
        </div>
      </div>
      <div v-if="loading">
        <v-card class="mb-2 pa-3" flat v-for="i in 3" :key="i">
          <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
        </v-card>
      </div>
      <div class="pa-2">
        <v-dialog v-model="d_detail" max-width="300">
          <v-card>
            <v-card-text class="px-2 pb-0">
              <v-container style="height: max-content" v-if="inventory">
                <div class="d-flex mb-1">
                  <v-avatar size="50" class="mr-2">
                    <img
                      :src="inventory.scholar.pp ? inventory.scholar.pp : ava"
                      class="obj_fit"
                      alt="isyan"
                    />
                  </v-avatar>
                  <div>
                    <b class="color_default">{{ inventory.scholar.name }}</b>
                    <p class="default_txt">{{ inventory.scholar.id }}</p>
                  </div>
                </div>
                <v-divider></v-divider>
                <div v-if="inventory.data.length" class="mt-2">
                  <div
                    v-for="(item, x) in inventory.data"
                    :key="`dwn-${x}`"
                    class="mb-2"
                  >
                    <div
                      class=""
                      v-if="
                        x != 0 &&
                        $date(inventory.data[x].created_at).format(
                          'YYYY MM DD'
                        ) !==
                          $date(inventory.data[x - 1].created_at).format(
                            'YYYY MM DD'
                          )
                      "
                    >
                      <v-icon class="mr-2">mdi-calendar</v-icon
                      ><b>{{
                        $date(item.created_at).format("DD,MMMM,YYYY")
                      }}</b>
                    </div>
                    <div class="" v-else-if="x == 0">
                      <v-icon class="mr-2">mdi-calendar</v-icon>
                      <b>{{ $date(item.created_at).format("DD,MMMM,YYYY") }}</b>
                    </div>

                    <div class="d-flex">
                      <div style="width: 30px"></div>
                      <p class="mb-0">
                        Download at
                        <b> {{ $date(item.created_at).format("HH:mm") }} </b>
                      </p>
                    </div>
                  </div>
                </div>
              </v-container>
            </v-card-text>
            <v-card-actions> </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar v-model="loadDetail" :timeout="-1">
          Loading for history...
        </v-snackbar>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import titlePage from "../../../components/atom/titlePage.vue";
export default {
  components: { titlePage },
  computed: {
    ...mapState({
      ava: (state) => state.ava,
    }),
    getYear() {
      let data = [];
      let year = parseInt(this.$date().format("YYYY"));
      for (let i = 2019; i <= year; i++) {
        data.push({
          state: i,
          abbr: i,
        });
      }
      data.push({
        state: "All Year",
        abbr: "",
      });
      return data;
    },
  },
  data() {
    return {
      loading: false,
      loadDetail: false,
      dataSet: null,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      find: "",
      year: "",
      type: "",
      listType: [
        {
          txt: "Regular",
          val: "regular",
        },
        {
          txt: "Non Regular",
          val: "non-regular",
        },
        {
          txt: "All type",
          val: "",
        },
      ],
      phase: "",
      listPhase: [
        {
          txt: "All Phase",
          val: "",
        },
        {
          txt: "Baseline",
          val: "baseline",
        },
        {
          txt: "Midline",
          val: "midline",
        },
        {
          txt: "Endline",
          val: "endline",
        },
      ],
      d_detail: false,
      inventory: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `migrations/report_summary/download?filter[name]=${this.find}&filter[year_tf]=${this.year}&filter[phase]=${this.phase}&page[number]=${this.page}&page[size]=${this.limit}&include=scholar`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    viewDetail(item) {
      let scholar = {
        name: item.scholar.name,
        id: item.scholar.no_tf,
        pp: item.scholar.profile_picture,
      };
      this.loadDetail = true;
      let data = {
        path: `migrations/report_summary/download/report/detail?scholar_id=${item.scholar_id}&period=${item.phase}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.inventory = {
            scholar: scholar,
            data: data,
          };
          this.d_detail = true;

          this.loadDetail = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loadDetail = false;
        });
    },
    exportData() {
      let data = {
        path: `migrations/report_summary/download/report/download?period=${this.phase}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          location.href = data.path;
        })
        .catch((e) => {
          this.$toast.error(e.message);
        });
    },
  },
};
</script>

<style scoped>
.custom_vgn >>> .v-pagination__item {
  box-shadow: none !important;
}
.custom_vgn >>> .v-pagination__navigation {
  box-shadow: none !important;
}
</style>